import * as React from 'react'
import {
  Colors,
  InlineChildren,
  StackChildren,
  Text,
} from '@doordash/design-language'
import styled from 'styled-components'
import { Attributes } from '../../../components/organisms/workflow-template/types'

const FlexCenterStackChildren = styled(StackChildren)`
  justify-content: center;
  align-items: center;
  text-align: center;
`

const BASE_URL = 'https://img.cdn4dd.com/s/managed/dasher/onboarding/'

export const ImageComponent = ({ ...props }: Attributes) => {
  const IMG_URL = `${BASE_URL}${props.file}`

  const imageWithText = (
    <>
      {props.pre_text && (
        <Text styles={Text.Styles.Caption1} color={Colors.SystemGrey80}>
          {props.pre_text}
        </Text>
      )}
      <img src={IMG_URL} height={props.height} width={props.width} alt="" />
      {props.post_text && (
        <Text styles={Text.Styles.Caption1} color={Colors.SystemGrey80}>
          {props.post_text}
        </Text>
      )}
    </>
  )

  return (
    <div>
      {props.alignment === 'HORIZONTAL' && (
        <InlineChildren
          alignItems={InlineChildren.Alignment.Center}
          justifyContent={InlineChildren.Justification.Center}
        >
          {imageWithText}
        </InlineChildren>
      )}

      {props.alignment === 'VERTICAL' && (
        <FlexCenterStackChildren>
          {imageWithText}
        </FlexCenterStackChildren>
      )}
    </div>
  )
}

export default ImageComponent
